<template>
  <div class="class_create">
    <div class="header">
      个人信息修改
    </div>
    <div class="content_box">
      <el-form :model="teacherObj" :rules="rules" ref="teacherForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="头像">
          <div style="display: flex;align-items: center;">
            <el-button v-model="teacherObj.t_ico" class="upload-btn" size="medium">
              <span style="width: 100%;height: 100%; display: block;">
                <!-- <i class="el-icon-plus" v-if="!teacherObj.t_ico"></i> -->
                <img style="width: 100%;height: 100%;object-fit: cover;border-radius: 100%;" v-if="!teacherObj.t_ico" src="../../assets/images/user_img.png" alt="">
                <img style="width: 100%;height: 100%;object-fit: cover;border-radius: 100%;" v-else :src="teacherObj.t_ico" alt=""></span>
              <input type="file" accept="image/*" title="" @change="changeFile($event)">
            </el-button>
            <span style="margin-left: 20px;font-size: 14px;color: #999999;">(建议尺寸比例1:1)</span>
          </div>
        </el-form-item>
        <el-form-item label="姓名" prop="t_name">
          <el-input v-model="teacherObj.t_name"></el-input>
        </el-form-item>
      </el-form>
      <div class="button_box">
        <el-button @click="goBack()">取消</el-button>
        <el-button style="background: #4F7BFD;color: #fff;" @click="confirm('teacherForm')">确定</el-button>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      teacherObj: {
        t_ico: "",
        t_name: "",
        image: "",
      },
      imgage_file: "",
      rules: {
        t_name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          { min: 1, max: 20, message: "长度在 1到 20 个字符", trigger: "blur" },
        ],
      },
      role: localStorage.getItem("role"),
    };
  },
  components: {},
  created() {
    this.role = localStorage.getItem("role");
    if (this.role == 3) {
      this.getTeacherDetial(0);
    } else {
      // 学生端
      // this.teacherObj.t_ico = localStorage.getItem("sIcon") || "";
      // this.teacherObj.t_name = localStorage.getItem("sUsername") || "";
      this.getsTudentDetial(0);
    }
  },
  methods: {
    getTeacherDetial(type) {
      let formData = new FormData();
      formData.append("t_id", localStorage.getItem("t_id"));
      this.$thttp.axiosPost(this.$api.teacherEditTeacher, formData, (res) => {
        if (res.code === 200) {
          this.teacherObj.t_name = res.data.t_name;
          this.teacherObj.t_ico = res.data.t_ico;
          localStorage.setItem("sIcon", res.data.t_ico);
          if (type == 1) {
            setTimeout(() => {
              location.reload();
            }, 1000);
          }
        }
      });
    },
    getsTudentDetial(type) {
      let formData = new FormData();
      formData.append("s_id", "12661");
      this.$http.axiosGetBy(
        this.$api.jdFindStudent,
        { s_id: localStorage.getItem("s_id") },
        (res) => {
          if (res.code === 200) {
            this.teacherObj.t_name = res.data.s_name;
            this.teacherObj.t_ico = res.data.s_ico;
            localStorage.setItem("sIcon", res.data.s_ico);
            if (type == 1) {
              setTimeout(() => {
                location.reload();
              }, 1000);
            }
          }
        }
      );
    },
    changeFile(event) {
      if (event.target.files.length === 0) return;
      let fileList = event.target.files[0];
      this.teacherObj.image = fileList;
      let url = "";
      let reader = new FileReader();
      reader.readAsDataURL(fileList);
      let that = this;
      reader.onload = function (e) {
        url = this.result.substring(this.result.indexOf(",") + 1);
        that.teacherObj.t_ico = "data:image/png;base64," + url;
      };
    },
    confirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.role == 3) {
            let formData = new FormData();
            formData.append("image", this.teacherObj.image);
            formData.append("t_name", this.teacherObj.t_name);
            formData.append("t_id", localStorage.getItem("t_id"));
            this.$thttp.axiosPost(
              this.$api.teacherSaveTeacher,
              formData,
              (res) => {
                if (res.code == 200) {
                  this.getTeacherDetial(1);
                  localStorage.setItem("sUsername",this.teacherObj.t_name)
                  this.$message.success("修改成功!");
                  this.$router.go(-1);
                } else {
                  this.$message.error(res.msg);
                }
              }
            );
          } else {
            let formData = new FormData();
            formData.append("image", this.teacherObj.image);
            formData.append("s_name", this.teacherObj.t_name);
            formData.append("s_id", localStorage.getItem("s_id"));
            this.$http.axiosPost(this.$api.jdSaveStudent, formData, (res) => {
              if (res.code == 200) {
                this.getsTudentDetial(1);
                localStorage.setItem("sUsername",this.teacherObj.t_name)
                this.$message.success("修改成功!");
                this.$router.go(-1);
              } else {
                this.$message.error(res.msg);
              }
            });
          }
          //
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.class_create {
  background: #fff;
  width: 100%;
  height: 100%;
  padding: 30px 18.75% 20px 18.75%;
  box-sizing: border-box;
  .header {
    font-weight: 500;
    font-size: 18px;
    color: #333333;
    line-height: 21px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    border-bottom: 1px solid #eaecf1;
    height: 51px;
    padding-left: 20px;
    box-sizing: border-box;
  }
  .content_box {
    width: 600px;
    padding-top: 50px;
    margin: 0 auto;
  }
}
.individualCenter {
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 20px;
  box-sizing: border-box;
  .header {
    height: 50px;
    width: 100%;
    display: flex;
    border-bottom: 1px solid #eaecf1;
  }
  .content {
    width: 100%;
    padding-top: 50px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    .form_box {
      width: 500px;
      //   background: skyblue;
      .footer {
        width: 100%;
        display: flex;
        justify-content: center;
        margin-top: 100px;
      }
    }
  }
}
.img_box {
  width: 100px;
  height: 100px;
  border: 1px solid #eaecf1;
  border-radius: 4px;
  font-size: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #dcdfe6;
  .img {
    width: 100%;
    height: 100%;
    border-radius: 4px;
    object-fit: cover;
  }
}
.upload-btn {
  position: relative;
  width: 100px;
  height: 100px;
  border: 1px solid #eaecf1;
  border-radius: 100px;
  font-size: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #dcdfe6;
  padding: 0 !important;
  input {
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    opacity: 0;
    cursor: pointer;
  }
}
.button_box {
  margin-top: 80px;
  display: flex;
  justify-content: center;
  .el-button {
    width: 88px;
    height: 36px;
    background: #f2f4f7;
    border-radius: 4px 4px 4px 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #3e3e3e;
    line-height: 16px;
    text-align: center;
    font-style: normal;
    text-transform: none;
  }
}
</style>
